import React from 'react';
import Modal from './Modal';
import Button from './Button';

const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = 'Confirmar ação',
  message = 'Tem certeza que deseja realizar esta ação?',
  confirmText = 'Confirmar',
  cancelText = 'Cancelar',
  type = 'warning', // warning, danger, info
  icon
}) => {
  const typeConfig = {
    warning: {
      bgColor: 'bg-yellow-100',
      iconColor: 'text-yellow-600',
      buttonVariant: 'primary',
      defaultIcon: '⚠️'
    },
    danger: {
      bgColor: 'bg-red-100',
      iconColor: 'text-red-600',
      buttonVariant: 'danger',
      defaultIcon: '🗑️'
    },
    info: {
      bgColor: 'bg-blue-100',
      iconColor: 'text-blue-600',
      buttonVariant: 'primary',
      defaultIcon: 'ℹ️'
    }
  };

  const config = typeConfig[type];

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title} size="sm">
      <div className="text-center">
        {/* Icon */}
        <div className={`mx-auto flex h-12 w-12 items-center justify-center rounded-full ${config.bgColor} mb-4`}>
          <span className={`text-2xl ${config.iconColor}`}>
            {icon || config.defaultIcon}
          </span>
        </div>

        {/* Message */}
        <p className="text-gray-700 mb-6">
          {message}
        </p>

        {/* Buttons */}
        <div className="flex gap-3 justify-center">
          <Button
            onClick={onClose}
            variant="secondary"
            size="sm"
          >
            {cancelText}
          </Button>
          <Button
            onClick={handleConfirm}
            variant={config.buttonVariant}
            size="sm"
          >
            {confirmText}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;